import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * XP to skip OWF upsell
 */
export const FE_SKIP_OWF_UPSELL_250409 = experiment({
  name: "FE_SKIP_OWF_UPSELL_250409",
  identifier: "SignUpSessionToken",
  client: [
    "RETAILER",
    "RETAILER_HEAD_TAGS",
    "VISITOR_WEB_HEAD_TAGS",
    "VISITOR_WEB",
    "HOTJAR_RETAILER",
  ],
  notifyAfter: "2025-07-10",
  defaultValue: false,
  productArea: "RETAILER_ONBOARDING",
});
